import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1ba2cebf"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "timeout-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedH2 = _resolveComponent("FriedH2");
    const _component_FriedSkeleton = _resolveComponent("FriedSkeleton");
    return (_openBlock(), _createElementBlock("div", {
        class: "loader-container",
        "data-external": "page-skeleton-loader-container",
        style: _normalizeStyle({ height: _ctx.pageHeight + 'px' })
    }, [
        (_ctx.timeoutCompleted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_FriedH2, { class: "timeout-message" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.timeoutMessage), 1)
                    ]),
                    _: 1
                })
            ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_FriedSkeleton, {
                    class: "heading",
                    type: _ctx.SkeletonType.H1
                }, null, 8, ["type"]),
                _createVNode(_component_FriedSkeleton, {
                    class: "paragraph",
                    type: _ctx.SkeletonType.Paragraph
                }, null, 8, ["type"]),
                _createVNode(_component_FriedSkeleton, {
                    class: "sub-heading",
                    type: _ctx.SkeletonType.H2
                }, null, 8, ["type"]),
                _createVNode(_component_FriedSkeleton, {
                    class: "paragraph",
                    type: _ctx.SkeletonType.Paragraph,
                    rows: 10
                }, null, 8, ["type"]),
                _createVNode(_component_FriedSkeleton, {
                    class: "sub-heading",
                    type: _ctx.SkeletonType.H2
                }, null, 8, ["type"]),
                _createVNode(_component_FriedSkeleton, {
                    class: "paragraph",
                    type: _ctx.SkeletonType.Paragraph,
                    rows: 14
                }, null, 8, ["type"])
            ], 64))
    ], 4));
}
